import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//******************************************************************************
//  NPM (Packages) External
//******************************************************************************
import { SDKLoadingModule } from 'sdk-loading';

//******************************************************************************
//  Services
//******************************************************************************
import { AppSettingsService } from '~/core/services/appsettings.service';
import { GraphService } from '~/core/services/graph.service';
import { FormatterService } from '~/core/services/formatter.service';

//******************************************************************************
//  Pages
//******************************************************************************
import { AuthComponent } from '~/core/pages/auth/auth.component';
import { LoginComponent } from '~/core/pages/auth/login.component';
import { NotFoundComponent } from '~/core/pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { HeaderComponent } from '~/core/components/layout/header/header.component';
import { NavComponent } from '~/core/components/layout/nav/nav.component';
import { FooterComponent } from '~/core/components/layout/footer/footer.component';
import { AccessComponent } from '~/core/components/access/access.component';
import { AlertComponent } from '~/core/components/alert/alert.component';
import { ErrorComponent } from '~/core/components/error/error.component';
import { WorkspaceSwitcherComponent } from '~/core/components/workspace-switcher/workspace-switcher.component';
import { AdminComponent } from '~/core/components/admin/admin.component';

const components: any[] = [
    HeaderComponent,
    NavComponent,
    FooterComponent,
    AccessComponent,
    AlertComponent,
    ErrorComponent,
    WorkspaceSwitcherComponent,
    AdminComponent,

    AuthComponent,
    LoginComponent,
    NotFoundComponent,
];

const services: any[] = [
    AppSettingsService,
    GraphService,
    FormatterService,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CurrencyPipe,
        DatePipe,
        DecimalPipe,

        SDKLoadingModule,
    ],
    declarations: [
        ...components,
    ],
    exports: [
        ...components,
    ],
    providers: [
        ...services,
    ],
})

export class CoreImports { }
